<template>
  <v-container grid-list-md class="py-0 px-2 ma-0">
    <v-row>
      <v-col cols="12" class="pt-0">
        <v-flex xs8 mx-auto>
          <v-card class="ma-2">
            <v-card-title class="pa-2 primary--text grey lighten-4">
              Search Employee Payroll Details
            </v-card-title>
            <v-form ref="sForm" @submit.prevent="SearchPayroll()">
              <v-card-text class="pt-0">
                <v-flex xs12 class="pt-0 pb-1">
                  <v-radio-group v-model="lPayroll.det_type" :mandatory="true" row class="pt-0" hide-details>
                    <v-radio label="Payroll details New" value="payroll_new" selected></v-radio>
                    <v-radio label="Payroll details Old" value="payroll"></v-radio>
                    <v-radio label="Form T" value="tform"></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-flex xs12>
                  <v-select
                  v-model="lPayroll.category"
                  label="Select category"
                  :items="['Active', 'Inactive']"
                  hide-details
                  ></v-select>
                </v-flex>
                <v-flex xs12 v-if="lPayroll.category === 'Active'">
                  <v-select
                  v-model="lPayroll.comm_id"
                  label="Project"
                  :items="commList"
                  item-text="comm_name"
                  item-value="comm_id"
                  hide-details
                  clearable
                  multiple
                  return-object
                  >
                  <template v-slot:prepend-item>
                    <v-list-item
                    ripple
                    @click="toggle"
                    >
                    <v-list-item-action>
                      <v-icon :color="lPayroll.comm_id && lPayroll.comm_id.length > 0 ? 'indigo darken-4' : ''">{{ icon }}</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>Select All</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
                </template>
              </v-select>
            </v-flex>
            <v-flex xs12 v-if="lPayroll.category === 'Inactive'">
              <v-select
              v-model="lPayroll.comm_id"
              label="Project"
              :items="inactiveCommList"
              item-text="comm_name"
              item-value="comm_id"
              hide-details
              clearable
              return-object
              multiple>
              <template v-slot:prepend-item>
                <v-list-item
                ripple
                @click="toggle"
                >
                <v-list-item-action>
                  <v-icon :color="lPayroll.comm_id && lPayroll.comm_id.length > 0 ? 'indigo darken-4' : ''">{{ icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>Select All</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2"></v-divider>
            </template>
          </v-select>
        </v-flex>
        <v-flex xs12 class="py-2">
          <v-layout row wrap>
            <v-flex xs6>
              <v-dialog ref="dlgstartDt"
              persistent v-model="dlgstartDt"
              max-width="290px"
              class="pt-0"
              :return-value.sync="lPayroll.month_start">
              <template v-slot:activator="{ on }">
                <v-text-field
                label="Month Start Date"
                v-model="lPayroll.month_start" append-icon="mdi-calendar-today"
                readonly
                v-on="on"
                hide-details
                ></v-text-field>
              </template>
              <v-date-picker @input="loadEndDateBasedOnStartingDate(lPayroll.month_start)"
              v-model="lPayroll.month_start"
              scrollable
              >
              <div class="flex-grow-1"></div>
              <v-btn text @click="dlgstartDt = false">Cancel</v-btn>
              <v-btn text color="accent" @click="$refs.dlgstartDt.save(lPayroll.month_start)">OK</v-btn>
            </v-date-picker>
          </v-dialog>
        </v-flex>
        <v-flex xs6>
          <v-dialog ref="dlgendDt"
          persistent v-model="dlgendDt"
          max-width="290px"
          class="pt-0"
          :return-value.sync="lPayroll.month_end">
          <template v-slot:activator="{ on }">
            <v-text-field
            slot="activator" label="Month End Date"
            v-model="lPayroll.month_end" append-icon="mdi-calendar-today"
            readonly
            hide-details
            v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
          :min="lPayroll.month_start"
          v-model="lPayroll.month_end"
          scrollable
          >
          <div class="flex-grow-1"></div>
          <v-btn text @click="dlgendDt = false">Cancel</v-btn>
          <v-btn text color="accent" @click="$refs.dlgendDt.save(lPayroll.month_end)">OK</v-btn>
        </v-date-picker>
      </v-dialog>
    </v-flex>
  </v-layout>
</v-flex>
</v-card-text>
<v-card-actions>
  <v-spacer></v-spacer>
  <v-btn @click="clear">Clear</v-btn>
  <v-btn type="submit" color="accent" :disabled="beingSaved">search</v-btn>
</v-card-actions>
</v-form>
</v-card>
</v-flex>

<v-flex xs12 class="pt-2" v-if="payRollList && payRollList.length > 0" grid-list-md>
  <v-card-title>
    <v-flex xs6 class="title primary--text pa-1">
      <span>Search Result ({{payRollList.length}} Records)</span>
    </v-flex>
    <v-flex xs6 class="text-right">
      <v-download-as
      :headers="employeePayrollHeader"
      :items="payRollList"
      title="Employee Payroll List"
      ></v-download-as>
    </v-flex>
  </v-card-title>
  <v-card>
    <v-card-text class="pa-0 ma-0">
      <v-data-table
      :headers="employeePayrollHeader"
      :items="payRollList"
      fixed-header
      dense
      height="450px"
      hide-default-footer
      disable-pagination
      :mobile-breakpoint="0"
      >
      <template slot="item" slot-scope="props">
        <tr>
          <td>{{ props.item.vendor_emp_id }}</td>
          <td>{{ props.item.emp_name }}</td>
          <td>{{ props.item.emp_desig }}</td>
          <td>{{ props.item.proj_name }}</td>
          <td>{{ props.item.payroll_cat }}</td>
          <td>{{ props.item.date_of_birth ? handy.formatDate(props.item.date_of_birth) : '-' }}</td>
          <td>{{ props.item.date_of_joining ? handy.formatDate(props.item.date_of_joining) : '-' }}</td>
          <td>{{ props.item.last_working_date ? handy.formatDate(props.item.last_working_date) : '-' }}</td>
          <td>{{ props.item.aadhar_no ? props.item.aadhar_no : '-' }}</td>
          <td>{{ props.item.uan ? props.item.uan : '-' }}</td>
          <td>{{ props.item.pf_no ? props.item.pf_no : '-' }}</td>
          <td>{{ props.item.esi_no ? props.item.esi_no : '-' }}</td>
          <td>{{ props.item.bank_acc_no ? props.item.bank_acc_no : '-' }}</td>
          <td>{{ props.item.bank_ifsc_code ? props.item.bank_ifsc_code : '-' }}</td>
          <td>{{ props.item.bank_name ? props.item.bank_name : '-' }}</td>
          <td>{{ props.item.budgeted_salary ? props.item.budgeted_salary : '-' }}</td>
          <td>{{ props.item.billing_salary ? props.item.billing_salary : '-' }}</td>
          <td>{{ props.item.takehome_salary ? props.item.takehome_salary : '-' }}</td>
          <td>{{ props.item.basic ? props.item.basic : '-' }}</td>
          <td>{{ props.item.da ? props.item.da : '-' }}</td>
          <td>{{ props.item.hra ? props.item.hra : '-' }}</td>
          <td>{{ props.item.conveyance ? props.item.conveyance : '-' }}</td>
          <td>{{ props.item.washing_allowance ? props.item.washing_allowance : '-' }}</td>
          <td>{{ props.item.other_allowance ? props.item.other_allowance : '-'}}</td>
          <td>{{ props.item.leave_wages ? props.item.leave_wages : '-' }}</td>
          <td>{{ props.item.incentive ? props.item.incentive : '-' }}</td>
          <td>{{ props.item.bonus ? props.item.bonus : '-'}}</td>
          <td>{{ props.item.child_edu_allowances ? props.item.child_edu_allowances : '-' }}</td>
          <td>{{ props.item.gross_salary ? props.item.gross_salary : '-' }}</td>
          <td>{{ props.item.tot_present }}</td>
          <td>{{ props.item.tot_wo }}</td>
          <td>{{ props.item.tot_holiday }}</td>
          <td>{{ props.item.tot_ot }}</td>
          <td>{{ props.item.tot_leave }}</td>
          <td>{{ props.item.tot_absent }}</td>
          <td>{{ props.item.billable }}</td>
          <td>{{ props.item.agreement }}</td>
        </tr>
      </template>
    </v-data-table>
  </v-card-text>
</v-card>
</v-flex>

<v-flex xs12 class="pt-2" v-if="attReportDet && attReportDet.length > 0" grid-list-md>
  <v-card-title>
    <v-flex xs6 class="title primary--text pa-1">
      <span>Search Result ({{attReportDet.length}} Records)</span>
    </v-flex>
    <v-flex xs6 class="text-right">
      <v-download-as
      :headers="repDetCalHeadSm"
      :items="attReportDet"
      title="Employee Payroll List"
      ></v-download-as>
    </v-flex>
  </v-card-title>
  <v-card>
    <v-card-text class="pa-0 ma-0">
      <v-data-table
      :headers="repDetCalHeadSm"
      :items="attReportDet"
      fixed-header
      dense
      height="450px"
      hide-default-footer
      disable-pagination
      :mobile-breakpoint="0"
      sort-by="proj_name"
      >
      <template slot="item" slot-scope="props">
        <tr>
          <td>{{ props.item.vendor_emp_id }}</td>
          <td>{{ props.item.emp_name }}</td>
          <td>{{ props.item.emp_desig }}</td>
          <td>{{ props.item.proj_name }}</td>
          <td>{{ props.item.payroll_cat }}</td>
          <td>{{ props.item.date_of_birth ? handy.formatDate(props.item.date_of_birth) : '-' }}</td>
          <td>{{ props.item.date_of_joining ? handy.formatDate(props.item.date_of_joining) : '-' }}</td>
          <td>{{ props.item.last_working_date ? handy.formatDate(props.item.last_working_date) : '-' }}</td>
          <td>{{ props.item.aadhar_no }}</td>
          <td>{{ props.item.uan }}</td>
          <td>{{ props.item.pf_no }}</td>
          <td>{{ props.item.esi_no }}</td>
          <td>{{ props.item.bank_acc_no }}</td>
          <td>{{ props.item.bank_ifsc_code }}</td>
          <td>{{ props.item.bank_name }}</td>
          <td>{{ props.item.budgeted_salary }}</td>
          <td>{{ props.item.billing_salary }}</td>
          <td>{{ props.item.takehome_salary }}</td>
          <td>{{ props.item.basic }}</td>
          <td>{{ props.item.da }}</td>
          <td>{{ props.item.hra }}</td>
          <td>{{ props.item.conveyance }}</td>
          <td>{{ props.item.washing_allowance }}</td>
          <td>{{ props.item.other_allowance }}</td>
          <td>{{ props.item.leave_wages }}</td>
          <td>{{ props.item.incentive }}</td>
          <td>{{ props.item.bonus }}</td>
          <td>{{ props.item.child_edu_allowances }}</td>
          <td>{{ props.item.gross_salary }}</td>
          <td :class="'px-1 py-0 text-center ' + (calday.attendance.includes('P') ? 'green' : calday.attendance.includes('A') ? 'red' : calday.attendance.includes('W') ? 'yellow' : (calday.attendance.includes('CL') || calday.attendance.includes('SL') || calday.attendance.includes('EL')) ? 'grey' : calday.attendance.includes('HD') ? 'green lighten-2' : calday.attendance.includes('H') ? 'blue' : !calday.attendance ? 'red lighten-4' : 'grey lighten-2')" v-for="(calday, i) in props.item.calendar" :key="i">
            <span v-if="calday.attendance" :class="calday.attendance === '-' ? 'title' : ''"><b>{{ calday.attendance }}</b></span>
          </td>
          <td>{{ props.item.tot_present }}</td>
          <td>{{ props.item.tot_wo }}</td>
          <td>{{ props.item.tot_holiday }}</td>
          <td>{{ props.item.tot_ot }}</td>
          <td>{{ props.item.tot_leave }}</td>
          <td>{{ props.item.tot_absent }}</td>
          <td>{{ props.item.tot_billable }}</td>
          <td>{{ props.item.agreement }}</td>
        </tr>
      </template>
    </v-data-table>
  </v-card-text>
  </v-card>
</v-flex>

<!-- snack bar for reporting -->
<v-snackbar :color="sbarCol" v-model="sbar"
:timeout="3000" multi-line><span class="mx-auto">{{ sbarMsg }}</span>
</v-snackbar>

<!-- loading -->
<div v-if="load" style="position:absolute; top:50%; left:40%">
  <v-progress-circular indeterminate color="info"></v-progress-circular>
</div>

</v-col>
</v-row>
</v-container>
</template>

<script>
import config from '@/config/app-cfg'
import handy from '@/utils/handy'
import VDownloadAs from './VDownloadAs.vue'

export default {
  components:
  {
    'v-download-as': VDownloadAs
  },
  data () {
    return {
      // common
      sbarMsg: '',
      sbar: false,
      sbarCol: 'error',
      handy: handy,
      rules: handy.rules,
      beingSaved: false,
      load: false,
      // payroll
      lPayroll: [],
      commList: [],
      inactiveCommList: [],
      dlgendDt: false,
      dlgstartDt: false,
      // search result
      payRollList: [],
      employeePayrollHeader: [
        { text: 'Emp Id' , value: 'vendor_emp_id', width: '90px' },
        { text: 'Emp Name' , value: 'emp_name' },
        { text: 'Designation' , value: 'emp_desig' },
        { text: 'Project' , value: 'proj_name' },
        { text: 'Payroll category' , value: 'payroll_cat', width: '110px' },
        { text: 'DOB' , value: 'date_of_birth', width: '120px' },
        { text: 'Joining Date' , value: 'date_of_joining', width: '120px' },
        { text: 'Left Date' , value: 'last_working_date', width: '90px', sortable: false },
        { text: 'AADHAR No' , value: 'aadhar_no' },
        { text: 'UAN Number' , value: 'uan' },
        { text: 'PF Number' , value: 'pf_no' },
        { text: 'ESI Number' , value: 'esi_no', width: '120px' },
        { text: 'Bank Acc No' , value: 'bank_acc_no' },
        { text: 'Bank IFSC Code' , value: 'bank_ifsc_code', width: '140px' },
        { text: 'Bank Name' , value: 'bank_name', width: '115px' },
        { text: 'Budget Salary' , value: 'budgeted_salary' },
        { text: 'Billing Salary' , value: 'billing_salary', width: '90px' },
        { text: 'Take Home Salary' , value: 'takehome_salary', width: '110px' },
        { text: 'Basic' , value: 'basic', width: '90px' },
        { text: 'DA' , value: 'da', width: '90px' },
        { text: 'HRA' , value: 'hra', width: '90px' },
        { text: 'Conveyance' , value: 'conveyance', width: '120px' },
        { text: 'Washing Allowance' , value: 'washing_allowance', width: '110px' },
        { text: 'Other Allowance' , value: 'other_allowance', width: '110px' },
        { text: 'Leave Wages' , value: 'leave_wages', width: '90px' },
        { text: 'Performance Incentives', value: 'incentive' },
        { text: 'Bonus' , value: 'bonus', width: '90px' },
        { text: 'Child Educational Allowance' , value: 'child_edu_allowances', width: '140px' },
        { text: 'Gross Salary' , value: 'gross_salary', width: '90px' },
        { text: 'P' , value: 'tot_present', sortable: false },
        { text: 'W' , value: 'tot_wo', sortable: false },
        { text: 'H' , value: 'tot_holiday', sortable: false },
        { text: 'O' , value: 'tot_ot', sortable: false },
        { text: 'L' , value: 'tot_leave', sortable: false },
        { text: 'A' , value: 'tot_absent', sortable: false },
        { text: 'Work Days' , value: 'billable', width: '90px' },
        { text: 'Month Days' , value: 'agreement', width: '90px' }
      ],
      attReportDet: [],
      repDetCalHeadSm: [], // constructed dynamically
      vendorStandby: []
    }
  },
  created () {
    this.loadCommunity()
    this.lPayroll = this.getEmptyPayRoll()
    this.lPayroll.det_type = 'payroll_new'
  },
  computed: {
    selectAllComm () {
      if (this.lPayroll.category === 'Active') {
        return this.lPayroll.comm_id.length === this.commList.length
      } else {
        return this.lPayroll.comm_id.length === this.inactiveCommList.length
      }
    },
    selectSomeComm () {
      return this.lPayroll.comm_id.length > 0 && !this.selectAllComm
    },
    icon () {
      if (this.selectAllComm) return 'mdi-close-box'
      if (this.selectSomeComm) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
  },
  methods: {
    msg (m, type = 0) {
      if (type === 0) {
        this.sbarCol = 'error'
      } else if (type === 1) {
        this.sbarCol = 'success'
      } else {
        this.sbarCol = 'info'
      }
      this.sbar = true
      this.sbarMsg = m
    },
    loadCommunity () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.commList = []
      this.axios.get(config.API_URL + '/getProjectCommList/', qry)
      .then(response => {
        this.commList = response.data
      })
      .catch(err => {
        this.msg(err, 0)
      })
      this.inactiveCommList = []
      this.axios.get(config.API_URL + '/getProjectInactiveCommList/', qry)
      .then(response => {
        this.inactiveCommList = response.data
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    getEmptyPayRoll () {
      var emptyPayRoll = {
        vendor_id: config.VENDOR_ID,
        category: 'Active',
        month_end: null,
        month_start: null,
        comm_id: [],
        det_type: 'payroll'
      }
      return emptyPayRoll
    },
    clear () {
      this.lPayroll.comm_id = []
      this.lPayroll.month_start = null
      this.lPayroll.month_end = null
      this.lPayroll.category = 'Active'
      this.attReportDet = []
      this.payRollList = []
      this.loadCommunity()
    },
    toggle () {
      this.$nextTick(() => {
        if (this.selectAllComm) {
          this.lPayroll.comm_id = []
        } else {
          if (this.lPayroll.category === 'Active') {
            this.lPayroll.comm_id = this.commList.slice()
          } else {
            this.lPayroll.comm_id = this.inactiveCommList.slice()
          }
        }
      })
    },
    loadEndDateBasedOnStartingDate (curDate) {
      var curDt = new Date(curDate)
      var date = curDt.getDate()
      if (date === 1) {
        this.lPayroll.month_end = handy.formatDBDate(new Date(curDt.getFullYear(), curDt.getMonth() + 1, 0))
      } else {
        curDt.setDate(date - 1)
        curDt.setMonth(curDt.getMonth() + 1)
        this.lPayroll.month_end = handy.formatDBDate(curDt)
      }
    },
    SearchPayroll () {
      if (!this.lPayroll.comm_id || !this.lPayroll.month_start || !this.lPayroll.month_end) {
        this.msg('Please enter all the fields', 0)
        return
      }
      this.attReportDet = []
      this.payRollList = []
      if (this.lPayroll.det_type === 'payroll_new' || this.lPayroll.det_type === 'payroll') {
        this.loadPayrollDetails ()
      } else if (this.lPayroll.det_type === 'tform') {
        this.refreshAttReportDet()
        this.loadVendorEmp()
      }
    },
    loadPayrollDetails () {
      this.load = true
      var qry = {
        params: {
          comm_id: this.lPayroll.comm_id.map(rec => rec.comm_id),
          from_dt: this.lPayroll.month_start,
          to_dt: this.lPayroll.month_end,
          proj_status: this.lPayroll.category === 'Active' ? 'Active' : 'Closed',
          payroll_det_type: this.lPayroll.det_type
        }
      }
      this.payRollList = []
      // this.lPayroll.comm_name = this.commList.filter(rec => rec.comm_id === this.lPayroll.comm_id)[0].comm_name
      this.axios.get(config.API_URL + '/getListOfEmployeePayrollForGivenDatesAndComm/', qry)
      .then(response => {
        if (response.data.length === 0) {
          this.msg('No records found for selected project list and for selected dates', 0)
        } else {
          this.payRollList = response.data
          this.payRollList.forEach(rec => {
            if (rec.tot_hd > 0) {
              rec.tot_present = rec.tot_present + (rec.tot_hd / 2)
              rec.billable = rec.billable + (rec.tot_hd / 2)
            }
          })
        }
        this.load = false
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    refreshAttReportDet () {
      this.load = true
      // construct detail based on view chosen by user
      this.attReportDet = []
      var qry = {
        params: {
          comm_id: this.lPayroll.comm_id.map(rec => rec.comm_id),
          from_dt: this.lPayroll.month_start,
          to_dt: this.lPayroll.month_end,
          proj_status: this.lPayroll.category === 'Active' ? 'Active' : 'Closed'
        }
      }
      this.axios.get(config.API_URL + '/getEmployeePayrollRep/', qry)
      .then(response => {
        // calculate few fields
        // construct calendar view from retrived data for every staff
        var tmpStaffId = -1
        var idx = -1
        var dtIdx = 29
        var addedDates = []
        var tmpDt = ''
        var curAtt = ''
        var sbyList = []
        this.repDetCalHeadSm = [
          { text: 'Emp Id' , value: 'vendor_emp_id', width: '90px', sortable: false },
          { text: 'Emp Name' , value: 'emp_name', sortable: false },
          { text: 'Designation' , value: 'emp_desig', sortable: false },
          { text: 'Project' , value: 'proj_name', sortable: false },
          { text: 'Payroll category' , value: 'payroll_cat', width: '110px', sortable: false },
          { text: 'DOB' , value: 'date_of_birth', width: '120px', sortable: false },
          { text: 'Joining Date' , value: 'date_of_joining', width: '120px', sortable: false },
          { text: 'Left Date' , value: 'last_working_date', width: '90px', sortable: false },
          { text: 'AADHAR No' , value: 'aadhar_no', sortable: false },
          { text: 'UAN Number' , value: 'uan', sortable: false },
          { text: 'PF Number' , value: 'pf_no', sortable: false },
          { text: 'ESI Number' , value: 'esi_no', width: '120px', sortable: false },
          { text: 'Bank Acc No' , value: 'bank_acc_no', sortable: false },
          { text: 'Bank IFSC Code' , value: 'bank_ifsc_code', width: '140px', sortable: false },
          { text: 'Bank Name' , value: 'bank_name', width: '115px', sortable: false },
          { text: 'Budget Salary' , value: 'budgeted_salary', sortable: false },
          { text: 'Billing Salary' , value: 'billing_salary', width: '90px', sortable: false },
          { text: 'Take Home Salary' , value: 'takehome_salary', width: '110px', sortable: false },
          { text: 'Basic' , value: 'basic', width: '90px', sortable: false },
          { text: 'DA' , value: 'da', width: '90px', sortable: false },
          { text: 'HRA' , value: 'hra', width: '90px', sortable: false },
          { text: 'Conveyance' , value: 'conveyance', width: '120px', sortable: false },
          { text: 'Washing Allowance' , value: 'washing_allowance', width: '110px', sortable: false },
          { text: 'Other Allowance' , value: 'other_allowance', width: '110px', sortable: false },
          { text: 'Leave Wages' , value: 'leave_wages', width: '90px', sortable: false },
          { text: 'Performance Incentives', value: 'incentive', sortable: false },
          { text: 'Bonus' , value: 'bonus', width: '90px', sortable: false },
          { text: 'Child Educational Allowance' , value: 'child_edu_allowances', width: '140px', sortable: false },
          { text: 'Gross Salary' , value: 'gross_salary', width: '90px', sortable: false },
          /* attendance for every calendar day added dynamically */
          { text: 'P', value: 'tot_present', class: 'green--text pa-2 text-center', align: 'right', sortable: false },
          { text: 'W', value: 'tot_wo', class: 'green--text pa-2 text-center', align: 'right', sortable: false },
          { text: 'H', value: 'tot_holiday', class: 'green--text pa-2 text-center', align: 'right', sortable: false },
          { text: 'S/O', value: 'tot_ot', class: 'green--text pa-2 text-center', align: 'right', sortable: false },
          { text: 'L', value: 'tot_leave', class: 'green--text pa-2 text-center', align: 'right', sortable: false },
          { text: 'A', value: 'tot_absent', class: 'red--text pa-2 text-center', align: 'right', sortable: false },
          { text: 'Work Days' , value: 'tot_billable', width: '90px', sortable: false },
          { text: 'Month Days' , value: 'agreement', width: '90px', sortable: false }
        ]
        response.data.forEach(rec => {
          // 1. one line item per staff
          if (tmpStaffId !== rec.vendor_emp_id) {
            this.attReportDet.push({
              staff_id: rec.staff_id,
              staff_name: rec.emp_name,
              staff_role_id: rec.staff_role_id,
              staff_role: rec.staff_role,
              vendor_emp_id: rec.vendor_emp_id,
              emp_name: rec.emp_name,
              emp_desig: rec.emp_desig,
              proj_name: rec.proj_name,
              payroll_cat: rec.payroll_cat,
              date_of_birth: rec.date_of_birth,
              date_of_joining: rec.date_of_joining,
              last_working_date: rec.last_working_date,
              aadhar_no: rec.aadhar_no,
              uan: rec.uan,
              pf_no: rec.pf_no,
              esi_no: rec.esi_no,
              bank_acc_no: rec.bank_acc_no,
              bank_ifsc_code: rec.bank_ifsc_code,
              bank_name: rec.bank_name,
              budgeted_salary: rec.budgeted_salary,
              billing_salary: rec.billing_salary,
              takehome_salary: rec.takehome_salary,
              basic: rec.basic,
              da: rec.da,
              hra: rec.hra,
              conveyance: rec.conveyance,
              washing_allowance: rec.washing_allowance,
              other_allowance: rec.other_allowance,
              leave_wages: rec.leave_wages,
              incentive: rec.incentive,
              bonus: rec.bonus,
              child_edu_allowances: rec.child_edu_allowances,
              gross_salary: rec.gross_salary,
              calendar: [],
              tot_present: 0,
              tot_absent: 0,
              tot_wo: 0,
              tot_holiday: 0,
              tot_ot: 0,
              tot_hd: 0,
              tot_pend: 0,
              tot_billable: 0,
              tot_leave: 0,
              agreement: rec.agreement
            })
            idx = this.attReportDet.length - 1
            tmpStaffId = rec.vendor_emp_id
          }
          curAtt = rec.attendance ? (rec.attendance === 'Half Day' ? 'HD' : rec.attendance === 'Casual Leave' ? 'CL' : rec.attendance === 'Sick Leave' ? 'SL' : rec.attendance === 'Earned Leave' ? 'EL' : rec.attendance === 'Present + RL' ? 'P+R' : rec.attendance.charAt(0)) : ''
          // 2. for summary
          if (curAtt) {
            if (rec.attendance.includes('Present')) {
              this.attReportDet[idx].tot_present++
            } else if (rec.attendance.includes('Absent')) {
              this.attReportDet[idx].tot_absent++
            } else if (rec.attendance.includes('Weekly Off')) {
              this.attReportDet[idx].tot_wo++
            } else if (rec.attendance.includes('Holiday')) {
              this.attReportDet[idx].tot_holiday++
            } else if (rec.attendance.includes('Leave')) {
              this.attReportDet[idx].tot_leave++
            } else if (rec.attendance === 'Half Day') {
              this.attReportDet[idx].tot_hd++
              // adjust present and absent accordingly
              this.attReportDet[idx].tot_present += 0.5
              this.attReportDet[idx].tot_absent += 0.5
            }
            if (rec.sby_vendor_emp_id || rec.sby_temp_staff_name) {
              curAtt = curAtt + '+S'
            }
            // handle ot seperately
            if (rec.attendance.includes('OT')) {
              this.attReportDet[idx].tot_ot++
              curAtt = curAtt + '+O'
            }
            if (rec.attendance.includes('Present + RL')) {
              this.attReportDet[idx].tot_ot++
            }
            this.attReportDet[idx].tot_billable = this.attReportDet[idx].tot_present + this.attReportDet[idx].tot_wo + this.attReportDet[idx].tot_holiday + this.attReportDet[idx].tot_ot + this.attReportDet[idx].tot_leave
          } else {
            this.attReportDet[idx].tot_pend++
          }
          // 3. dynamic dates for table heading
          if (!addedDates.includes(rec.att_dt)) {
            addedDates.push(rec.att_dt)
          }
          // 4.1 attendance detail for table
          this.attReportDet[idx].calendar.push({
            att_dt: rec.att_dt,
            attendance: curAtt
          })
          // 5. standby handling
          if (rec.sby_vendor_emp_id || rec.sby_temp_staff_name) {
            // add a line item for standby
            sbyList.push({
              sby_staff_id: rec.sby_vendor_emp_id || rec.sby_temp_staff_name,
              emp_name: rec.sby_vendor_emp_id ? this.vendorStandby.find(emp => emp.vendor_emp_id === rec.sby_vendor_emp_id).emp_name : rec.sby_temp_staff_name,
              staff_role_id: rec.staff_role_id,
              proj_name: rec.proj_name,
              emp_desig: rec.staff_role + ' [Sby]',
              payroll_cat: rec.sby_vendor_emp_id ? rec.payroll_cat : '-',
              date_of_birth: rec.sby_vendor_emp_id ? rec.date_of_birth : null,
              date_of_joining: rec.sby_vendor_emp_id ? rec.date_of_joining : null,
              last_working_date: rec.sby_vendor_emp_id ? rec.last_working_date : null,
              aadhar_no: rec.sby_vendor_emp_id ? rec.aadhar_no : '-',
              uan: rec.sby_vendor_emp_id ? rec.uan : '-',
              pf_no: rec.sby_vendor_emp_id ? rec.pf_no : '-',
              esi_no: rec.sby_vendor_emp_id ? rec.esi_no : '-',
              bank_acc_no: rec.sby_vendor_emp_id ? rec.bank_acc_no : '-',
              bank_ifsc_code: rec.sby_vendor_emp_id ? rec.bank_ifsc_code : '-',
              bank_name: rec.sby_vendor_emp_id ? rec.bank_name : '-',
              budgeted_salary: rec.sby_vendor_emp_id ? rec.budgeted_salary : '-',
              billing_salary: rec.sby_vendor_emp_id ? rec.billing_salary : '-',
              takehome_salary: rec.sby_vendor_emp_id ? rec.takehome_salary : '-',
              basic: rec.sby_vendor_emp_id ? rec.basic : '-',
              da: rec.sby_vendor_emp_id ? rec.da : '-',
              hra: rec.sby_vendor_emp_id ? rec.hra : '-',
              conveyance: rec.sby_vendor_emp_id ? rec.conveyance : '-',
              washing_allowance: rec.sby_vendor_emp_id ? rec.washing_allowance : '-',
              other_allowance: rec.sby_vendor_emp_id ? rec.other_allowance : '-',
              leave_wages: rec.sby_vendor_emp_id ? rec.leave_wages : '-',
              incentive: rec.sby_vendor_emp_id ? rec.incentive : '-',
              bonus: rec.sby_vendor_emp_id ? rec.bonus : '-',
              child_edu_allowances: rec.sby_vendor_emp_id ? rec.child_edu_allowances : '-',
              gross_salary: rec.sby_vendor_emp_id ? rec.gross_salary : '-',
              vendor_emp_id: rec.sby_vendor_emp_id || '',
              staff_role: rec.staff_role,
              tot_present: 0,
              tot_absent: 0,
              tot_wo: 0,
              tot_holiday: 0,
              tot_hd: 0,
              tot_pend: 0,
              tot_leave: 0,
              agreement: rec.agreement,
              tot_ot: 1,
              tot_billable: 1,
              calendar: [{att_dt: rec.att_dt, attendance: 'S', tmp_dt: tmpDt}]
            })
          }
        })
        // post processing
        // sort dates in case
        addedDates = addedDates.sort()
        addedDates.forEach(dt => {
          // a.create dynamic column headers based on dates accumalated
          tmpDt = new Date(dt)
          tmpDt = tmpDt.getDate() + '/' + (tmpDt.getMonth() + 1)
          this.repDetCalHeadSm.splice(dtIdx++, 0, {
            text: tmpDt, value: tmpDt, class: 'px-1 py-0 text-center', align: 'center', columnWidth: 4, sortable: false
          })
          // b. arrange attendance based on sorted dates
          this.attReportDet.forEach(det => {
            calDtIdx = det.calendar.findIndex(cal => cal.att_dt === dt)
            if (calDtIdx === -1) {
              curAtt = '-'
              det.calendar.push({att_dt: dt, attendance: curAtt})
            } else {
              curAtt = det.calendar[calDtIdx].attendance
              det.calendar.push(det.calendar[calDtIdx])
              det.calendar.splice(calDtIdx, 1)
            }
            // detail for pdf/csv export
            det[tmpDt] = curAtt
          })
        })
        // insert standbys at appropriate places (grouped by role)
        if (sbyList.length) {
          var roleSbyList = []
          var curStaffIdx = -1
          var roleStaffSbyList = []
          var roleIdx = -1
          var calDtIdx = -1
          handy.unique(sbyList.map(rec => rec.staff_role_id)).forEach(role => {
            // filter each role
            roleSbyList = sbyList.filter(sby => sby.staff_role_id === role)
            // group by staff
            roleSbyList.forEach(sby => {
              curStaffIdx = roleStaffSbyList.findIndex(rsby => rsby.sby_staff_id === sby.sby_staff_id)
              if (curStaffIdx >= 0) {
                roleStaffSbyList[curStaffIdx].tot_ot++
                roleStaffSbyList[curStaffIdx].tot_billable++
                roleStaffSbyList[curStaffIdx].calendar.push(sby.calendar[0])
                roleStaffSbyList[curStaffIdx][sby.calendar[0].tmp_dt] = 'S' // for pdf/csv
              } else {
                roleStaffSbyList.push(sby)
              }
            })
            // fill-in attendance for non standby dates for every staff
            roleStaffSbyList.forEach(rsby => {
              // a. fill-in attendance for non standby dates
              addedDates.forEach(dt => {
                tmpDt = new Date(dt)
                tmpDt = tmpDt.getDate() + '/' + (tmpDt.getMonth() + 1)
                calDtIdx = rsby.calendar.findIndex(cal => cal.att_dt === dt)
                if (calDtIdx === -1) {
                  curAtt = '-'
                  rsby.calendar.push({att_dt: dt, attendance: curAtt})
                } else {
                  curAtt = 'S'
                  rsby.calendar.push(rsby.calendar[calDtIdx])
                  rsby.calendar.splice(calDtIdx, 1)
                }
                rsby[tmpDt] = curAtt // for pdf/csv
              })
            })
            // insert all these staff records at appropriate place in main attendance (end of concerned group)
            roleIdx = this.attReportDet.map(rep => rep.staff_role_id).lastIndexOf(role)
            this.attReportDet.splice(roleIdx + 1, 0, ...roleStaffSbyList)
            roleStaffSbyList = []
          }) // for ever role
        }
        this.pageRefKey++ // forces the detail table to re-render
        this.$forceUpdate()
        this.load = false
      })
      .catch(err => {
        this.msg(err, 0)
        this.load = false
      })
    },
    loadVendorEmp () {
      return new Promise((resolve, reject) => {
        var qry = {
          params: {
            vendor_id: config.VENDOR_ID
          }
        }
        this.vendorStandby = []
        this.axios.get(config.SMARTILITY_API_URL + '/getEmpByVendorId/', qry)
        .then(response => {
          this.vendorStandby = response.data
          resolve(true)
        })
        .catch(err => {
          this.msg(err.response.data, true)
          resolve(true)
        })
      })
    }
  }
}
</script>

<style>
.my-label-text-size .v-label {
  font-size: 14px !important;
}
</style>
